<template>
  <div class="flex flex-col w-full">
    <!-- Header section -->
    <div class="flex flex-col w-full pb-2 title-section">
      <h2 class="text-2xl font-body">
        <slot name="title" />
      </h2>
      <p class="py-1 text-lg">
        <slot name="subtitle" />
      </p>
    </div>

    <div class="flex w-full items-end gap-1 mb-3">
      <div class="flex flex-col w-full">
        <div v-if="props.showDiscountedPrice" class="flex items-end gap-1">
          <h3 class="old-price">
            <slot name="old-price" />
          </h3>
        </div>
        <div class="flex items-end gap-1">
          <h3 class="price">
            <slot name="price" />
          </h3>
          <span class="text-typo-tertiary">
            <slot name="price-suffix" />
          </span>
        </div>
      </div>
    </div>

    <slot name="action" />
    <span
      v-if="$slots['billing-appendix']"
      class="text-typo-tertiary block text-2xs !mt-2 billing-appendix w-full text-center px-2 truncate"
      :class="billingAppendixStyle"
    >
      <slot name="billing-appendix" />
    </span>
    <hr v-if="$slots['plan-description'] && !Flipper.isEnabled('pricing_page_new_layout_experiment')" class="divider" />
    <div class="flex flex-col w-full" v-if="!Flipper.isEnabled('pricing_page_new_layout_experiment')">
      <slot name="plan-description" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Flipper from "@/modules/flipper";
import { computed } from "vue";

const props = defineProps<{
  showDiscountedPrice?: boolean;
}>();

const isExperimentEnabled = computed(() => Flipper.isEnabled("pricing_page_new_layout_experiment"));

const billingAppendixStyle = computed(() => ({
  "appendix-position": isExperimentEnabled.value,
}));
</script>

<style scoped>
.price {
  font-weight: bold;
  margin: 0;
  font-variation-settings: "opsz" 100;
}

.appendix-position {
  position: absolute;
  bottom: 0.25rem;
  left: 50%;
  transform: translateX(-50%);
}

.title-section {
  min-height: 9rem;
}

.divider {
  margin: 1.5rem 0;
}

.billing-appendix {
  min-height: 1rem;
}

.price-align-bottom {
  align-items: flex-end;
}

.old-price {
  min-height: 2rem;
  font-size: 1.5rem;
  font-weight: 400;
  font-variation-settings: "opsz" 100;
  color: rgb(173, 182, 188);
  position: relative;
  margin-bottom: 0rem;

  text-decoration: line-through;
  text-decoration-color: rgb(173, 182, 188);

  text-decoration-thickness: 2px;
  text-decoration-style: solid;
}
</style>
